<template>
  <div class="jump-cart">
      <van-nav-bar title="消息" left-arrow fixed class="jump-nav-bar" @click-left="back" />
      <div class="jump-cart-body">
        <div class="jump-cart-body-hd"></div>
        <div class="jump-usercent-header-hd">
          <van-row class="jump-usercent-header" type="flex">
            <van-col span="12" >
              <a href="#/user/message">
                <p class="bg-green"><i class="iconfont icon-notice"></i></p>
                <h5>站内消息</h5>
              </a>
            </van-col>
            <van-col span="12" >
              <a href="#/user/cons">
                <p class="bg-orange"><i class="iconfont icon-xiaoxi"></i></p>
                <h5>站内咨询</h5>
              </a>
            </van-col>
            <!-- <van-col span="8" >
                <p class="bg-blue"><i class="iconfont icon-dingdan-"></i></p>
                <h5>订单提醒</h5>
            </van-col> -->
        </van-row>
        </div>
<usermessage style="margin-top: -50px;"></usermessage>
        <!--<van-row class="jump-messg-item">
          <van-col span="12">
                <p class="item-header">admin <span>已读</span> </p>
          </van-col>
          <van-col span="12">
                <p class="item-time">2019-06-17 17:50:28 <van-icon name="delete" /></p>
          </van-col>
          <van-col span="24">
                <p class="item-cont"><span>标题:</span>【爆款产品价格直降，大品牌决定好品质】</p>
          </van-col>
      </van-row>
      <van-row class="jump-messg-item noread">
          <van-col span="12">
                <p class="item-header">admin <span>未读</span> </p>
          </van-col>
          <van-col span="12">
                <p class="item-time">2019-06-17 17:50:28 <van-icon name="delete" /></p>
          </van-col>
          <van-col span="24">
                <p class="item-cont"><span>标题:</span>【爆款产品价格直降，大品牌决定好品质】</p>
          </van-col>
      </van-row>
        <van-row class="jump-messg-item">
            <van-col span="10">
                  <p class="item-header">admin <span>已回复</span> </p>
            </van-col>
            <van-col span="14">
                  <p class="item-time">2019-06-17 17:50:28 <van-icon name="delete" /></p>
            </van-col>
            <van-col span="24">
                  <p><span>标题:</span>有关生产日期的问题?</p>
            </van-col>
            <van-col span="24" class="text-right">
                  <a >查看</a><van-button size="small">回复</van-button>
            </van-col>
        </van-row>
        <van-row class="jump-messg-item noread">
          <van-col span="12">
                <p class="item-header">admin <span>未读</span> </p>
          </van-col>
          <van-col span="12">
                <p class="item-time">2019-06-17 17:50:28 <van-icon name="delete" /></p>
          </van-col>
          <van-col span="24">
                <p class="item-cont"><span>标题:</span>【爆款产品价格直降，大品牌决定好品质】</p>
          </van-col>
      </van-row>
      <van-row class="jump-messg-item noread">
          <van-col span="12">
                <p class="item-header">admin <span>未读</span> </p>
          </van-col>
          <van-col span="12">
                <p class="item-time">2019-06-17 17:50:28 <van-icon name="delete" /></p>
          </van-col>
          <van-col span="24">
                <p class="item-cont"><span>标题:</span>【爆款产品价格直降，大品牌决定好品质】</p>
          </van-col>
      </van-row>-->
      </div>
	  
        <van-tabbar v-model="tabActive" active-color="#3c6eeb">
            <van-tabbar-item  url="#/home">
                <i slot="icon" class="iconfont icon-shouye"></i>
            首页</van-tabbar-item>
            <van-tabbar-item icon="label-o" url="#/cate">
                <i slot="icon" class="iconfont icon-icon-"></i>
                分类</van-tabbar-item>
            <van-tabbar-item icon="label-o" url="#/message/center">
                <i slot="icon" class="iconfont icon-ico_msg"></i>
                消息</van-tabbar-item>
            <van-tabbar-item icon="cart-o" url="#/cart">
                <i slot="icon" class="iconfont icon-gouwuche1"></i>
                购物车</van-tabbar-item>
            <van-tabbar-item icon="contact" url="#/usercent">
                <i slot="icon" class="iconfont icon-ziyuan2"></i>
                我的</van-tabbar-item>
        </van-tabbar>
        <BackTop />
    </div>
</template>
<script>
import { NavBar, Row, Col, Button,Tabbar ,TabbarItem} from "vant";
import Usermessage from "./UserMessage";
export default {
  name: "usermessageCenter",
  components: {
      Usermessage,
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
	[Tabbar.name]:Tabbar,
	[TabbarItem.name]:TabbarItem
  },
  data() {
    return {
      tabActive:2
    };
  },
  methods: {
    back() {
      history.back();
    }
  },
  // mounted(){
  //   if(!this.$api.isLogin()){
  //     location.href = "#/login";
  //   }
  // }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;

body {
  background-color: #f7f7f7;
}

.jump-cart {

    padding-bottom: 50px;
  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  &-body {
    padding: 20px 0;
    position: relative;
    &-hd {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 80px;
      background-color: @bule-thame;
    }
  }
}
.jump-usercent-header-hd{
  padding: 0 20px;
  margin-bottom: 20px;
}
.jump-usercent-header {
  padding: 15px 0 10px;
  background-color: #fff;
  text-align: center;
  position: relative;
  border-radius: 15px;
  h5 {
    color: #666;
    font-size: 16px;
    padding-top: 5px;
  }
  p{
    display: inline-block;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    line-height: 50px;
    i{
        color: #fff;
        font-size: 26px;
        vertical-align: -4px;
    }
  }
}
.jump-messg-item {
  padding: 10px;
  border-radius: 15px;
  background-color: #fff;
  margin-top: 10px;
  position: relative;
  p {
    font-size: 16px;
  }
  .van-button {
    padding: 0 15px;
    background-color: @bule-thame;
    border-color: @bule-thame;
    color: #fff;
    font-size: 14px;
    border-radius: 8px;
    margin-left: 10px;
  }
  .item-header {
    color: @bule-thame;
    font-size: 16px;
    margin-bottom: 10px;
    span {
      margin-left: 10px;
      color: @bule-thame;
      &.noread {
        color: red;
      }
    }
  }
  .item-time {
    text-align: right;
    font-size: 16px;
    i {
      color: @bule-thame;
      font-size: 18px;
      vertical-align: -2px;
      margin-left: 5px;
    }
  }
  &.noread{
    p.item-cont{
      color: #ccc;
    }
    p.item-header span{
        color: #dc3545;
    }
  }
}

.bg-blue{
  background-color: #007bff !important;
}
.bg-orange{
  background-color: #fd7e14 !important;
}
.bg-green{
  background-color: #28a745 !important;
}
</style>